import { TPageType } from 'shared/types/features';
import { FIRST_BLOCK_CONTENT } from '../constants';

export const getContentForFirstBlock = (page: TPageType) => {
  return FIRST_BLOCK_CONTENT[page] || FIRST_BLOCK_CONTENT['main'];
};
